// The one owner of the boilerplate markup. The div wrapper keeps the org text from merging into the
// rep's last block.
const appendEmailBoilerplate = (body: string, boilerplateText: string): string =>
  boilerplateText ? `${body}<div>${boilerplateText}</div>` : body;

export default appendEmailBoilerplate;
